import React from 'react';
import { Box, Typography } from '@mui/material';
import T from '../theme';
import { ImpactBadge, WhyThisMatters } from '../components/Shared.jsx';

export function SponsorSuggestions({ data }) {
  const { sponsorableAngles = [], sponsorSuggestions = [], cpmEstimates = {}, pitchStrategy = [] } = data;

  return (
    <Box>
      {sponsorableAngles.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.primary, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>Sponsorable Angles</Typography>
          {sponsorableAngles.map((a, i) => (
            <Box key={i} sx={{ mb: 1, p: 1.75, background: 'rgba(249,115,22,0.07)', border: `1px solid rgba(249,115,22,0.25)`, borderRadius: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
                <Typography sx={{ fontWeight: 700, fontSize: 13, color: T.text }}>{a.angle}</Typography>
                <ImpactBadge value={a.strength} />
              </Box>
              <Typography sx={{ fontSize: 12, color: T.textSecondary }}>Audience: {a.audience}</Typography>
              <Typography sx={{ fontSize: 12, color: T.textSecondary }}>Appeal: {a.appeal}</Typography>
            </Box>
          ))}
        </Box>
      )}

      {sponsorSuggestions.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.success, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>Sponsor Matches</Typography>
          {sponsorSuggestions.map((s, i) => (
            <Box key={i} sx={{ mb: 1, p: 1.75, background: 'rgba(34,197,94,0.06)', border: `1px solid rgba(34,197,94,0.25)`, borderRadius: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 14, color: T.text }}>{s.company}</Typography>
                <ImpactBadge value={s.fitScore} />
              </Box>
              <Typography sx={{ fontSize: 12, color: T.textSecondary, mb: 0.25 }}>{s.rationale}</Typography>
              <Typography sx={{ fontSize: 12, color: T.accent, fontStyle: 'italic' }}>Pitch: {s.pitchAngle}</Typography>
            </Box>
          ))}
        </Box>
      )}

      {(cpmEstimates.daiAdvertisingInsert || cpmEstimates.hostReadAdvertising) && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.textSecondary, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>CPM Estimates</Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
            {[['DAI / Programmatic', cpmEstimates.daiAdvertisingInsert], ['Host-Read', cpmEstimates.hostReadAdvertising]].map(([label, est]) => est && (
              <Box key={label} sx={{ p: 2, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 1.5, textAlign: 'center' }}>
                <Typography sx={{ fontSize: 18, fontWeight: 700, color: T.accent }}>${est.min}–${est.max}</Typography>
                <Typography sx={{ fontSize: 11, color: T.textSecondary, textTransform: 'uppercase', mt: 0.5 }}>{label} CPM</Typography>
                <Typography sx={{ fontSize: 11, color: T.textSecondary, mt: 0.25, fontStyle: 'italic' }}>{est.source}</Typography>
              </Box>
            ))}
          </Box>
          {cpmEstimates.note && <Typography sx={{ fontSize: 12, color: T.textSecondary, mt: 1, fontStyle: 'italic' }}>{cpmEstimates.note}</Typography>}
        </Box>
      )}

      {pitchStrategy.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.textSecondary, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1 }}>Pitch Strategy</Typography>
          {pitchStrategy.map((s, i) => (
            <Box key={i} sx={{ mb: 0.75, display: 'flex', gap: 1 }}>
              <span style={{ color: T.primary, flexShrink: 0 }}>→</span>
              <Box>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.text }}>{s.strategy}</Typography>
                <Typography sx={{ fontSize: 12, color: T.textSecondary }}>{s.rationale}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}

      <WhyThisMatters text="Sponsorships are the primary revenue driver for podcasts. A targeted pitch converts better." citations={data.expertCitations} />
    </Box>
  );
}
